import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAdminStore } from '../../store/adminStore';
import './AdminLogin.css';

export default function AdminLogin() {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const login = useAdminStore(state => state.login);

    // Optimize for Telegram Mini App
    useEffect(() => {
        if ((window as any).Telegram?.WebApp) {
            const tg = (window as any).Telegram.WebApp;
            tg.expand();
            tg.ready();
        }
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(password);
        } catch (err) {
            setError('Invalid password. Access denied.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-overlay">
            <motion.div
                className="admin-login-modal glass"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
            >
                <div className="admin-login-header">
                    <div className="admin-logo">⚡</div>
                    <h1 className="admin-title">Ghost-Flash-$USDT$</h1>
                    <p className="admin-subtitle">Admin Access</p>
                </div>

                <form onSubmit={handleSubmit} className="admin-login-form">
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter admin password"
                            className="admin-input"
                            autoFocus
                            disabled={loading}
                        />
                    </div>

                    {error && (
                        <motion.div
                            className="error-message"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                        >
                            ⚠️ {error}
                        </motion.div>
                    )}

                    <button
                        type="submit"
                        className="admin-login-btn"
                        disabled={loading || !password}
                    >
                        {loading ? (
                            <span className="loading-spinner">⟳</span>
                        ) : (
                            'Access Dashboard'
                        )}
                    </button>
                </form>

                <div className="admin-login-footer">
                    <p>Authorized personnel only</p>
                </div>
            </motion.div>
        </div>
    );
}
